import { useParams } from "react-router";
import { MachineGroupDetails } from "./MachineGroupDetails";

export const MachineGroupDetailsRoute: React.FC = () => {
  const { machineGroupId } = useParams<{
    machineGroupId: string;
  }>();
  if (!machineGroupId) {
    return null;
  }

  return (
    <MachineGroupDetails key={machineGroupId} machineGroupId={machineGroupId} />
  );
};
